module.exports = __webpack_public_path__ + "img/no-content1.033a909c.png";